import React from "react";
import styles from "./styles.module.scss";
import UITextField from "../../../../components/common/ui-components/input/UITextField";
import UITextArea from "../../../../components/common/ui-components/input/UITextArea";
import Button from "../../../../components/common/ui-components/input/Button";
import { ContactUs } from "../../../../api/landingpages";
import { cleverTapTrigger } from "../../../../tracking/segment";
import { validateDetails } from "../../../../utils";
import { regExpEmail } from "../../../../constants";
import Image from "@/components/UI/Image";

interface FormData {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  message: string;
}

const Form: React.FC = () => {
  const [formData, setFormData] = React.useState<FormData>({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [error, setError] = React.useState<object>({});
  const [btnLoading, setBtnLoading] = React.useState<boolean>(false);
  const [submitted, setSubmitted] = React.useState<boolean>(false);

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    }));
  };

  const handleSubmit = () => {
    setBtnLoading(true);
    const missingFields = validateDetails(formData, Object.keys(formData));
    if (Object.keys(missingFields).length > 0) {
      setError(missingFields);
      setBtnLoading(false);
      return;
    }
    if (!regExpEmail.test(formData.email)) {
      setError({
        email: "Please enter a valid email address",
      });
      setBtnLoading(false);
      return;
    }
    if (formData.phone.length !== 10) {
      setError({
        phone: "Please enter a valid phone number",
      });
      setBtnLoading(false);
      return;
    }
    ContactUs(formData)
    .then((response) => {
        cleverTapTrigger("Get In Touch Details Submitted", formData);
        setSubmitted(true);
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
      })
      .finally(() => {
        setBtnLoading(false);
      });
  };

  return (
    <div className={styles.formContainer}>
      <h4 className={styles.formTitle}>Get in touch with us</h4>
      {!submitted ? (
        <form className={styles.form}>
          <div className={styles.firstName}>
            <i></i>
            <UITextField
              label=""
              onChange={handleInputChange}
              placeholder="First Name"
              className={styles.b2bFormInput}
              id="first_name"
              value={formData.first_name}
              propsError={error["first_name"]}
            />
          </div>
          <div className={styles.lastName}>
            <i></i>
            <UITextField
              label=""
              onChange={handleInputChange}
              placeholder="Last Name"
              id="last_name"
              value={formData.last_name}
              className={styles.b2bLastNameInput}
              propsError={error["last_name"]}
            />
          </div>
          <div className={styles.email}>
            <i></i>
            <UITextField
              type="email"
              label=""
              onChange={handleInputChange}
              placeholder="Email"
              className={styles.b2bFormInput}
              id="email"
              value={formData.email}
              propsError={error["email"]}
            />
          </div>
          <div className={styles.phone}>
            <i></i>
            <UITextField
              type="tel"
              label=""
              onChange={handleInputChange}
              placeholder="Phone Number"
              className={styles.b2bFormInput}
              maxLength={10}
              id="phone"
              value={formData.phone}
              propsError={error["phone"]}
            />
          </div>
          <div className={styles.textArea}>
            <i></i>
            <UITextArea
              label="Your message"
              onChange={handleInputChange}
              value={formData.message}
              id="message"
              propsError={error["message"]}
            />
          </div>
          <Button
            onClick={handleSubmit}
            className={styles.b2bFormBtn}
            text="SUBMIT"
            loading={btnLoading}
            variant="green"
          />
        </form>
      ) : (
        <div className={styles.successfulSubmission}>
          <div className={styles.verified_image}>
            <Image
              src="/static/images/b2b/landingpage/verified.svg"
              alt="verified"
              height="48"
              width="48"
            />
          </div>
          <div className={styles.verified_title}>
            Thank you for reaching out!
          </div>
          <div className={styles.verified_message}>
            Our team will connect with you soon.
          </div>
        </div>
      )}
    </div>
  );
};
export default Form;
